import { PartialUser } from './user'

/**
 * A message room as stored in the database
 */
type StoredRoom = {
  avatarUsers: PartialUser[]
  created: number
  id: string
  lastMessage?: Message // The most recent message in the room, could be used for sorting in the future
  name: string
  reference: { ids?: string[]; type: RoomTypes; postId?: string; completionId?: string } // Type of room and ids associated with that type, for use in access-control logic
}

/**
 * A message room, including metadata pertaining to the current user's relationship to the room
 */
export type Room = StoredRoom & {
  meta: { lastViewed?: number; newMessageCount?: number }
}

/**
 * A message is associated with a room, contains basic information needed to display the message
 */
export type Message = {
  body: string
  created: number
  creator: PartialUser
  id: string
}

export enum RoomTypes {
  POST = 'post',
  COMPLETION = 'completion',
  DIRECT = 'direct',
  PROGRAM = 'program',
}
